import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const validKeys = ['mia-chiave-segreta', 'altra-chiave-valida'];

const ProtectedGuide = () => {
  const [searchParams] = useSearchParams();
  const [accessGranted, setAccessGranted] = useState(false);

  useEffect(() => {
    const key = searchParams.get('key');
    setAccessGranted(validKeys.includes(key));
  }, [searchParams]);

  if (!accessGranted) {
    return <div className="access-denied">Accesso non autorizzato</div>;
  }

  return <GuideContent />;
};

const GuideContent = () => {
  return (
    <div className="guide-container">
      <h1>Benvenuto nella guida privata!</h1>
      <p>Qui puoi inserire tutto il contenuto che vuoi mostrare.</p>
    </div>
  );
};

export default ProtectedGuide;
